export default "__VITE_PUBLIC_ASSET__004bffc0__"